import { useAuth } from 'react-oidc-context';

const useAuthToken = () => {
  const auth = useAuth();
  return auth.user?.access_token || '';
};

export default useAuthToken;
